import { gql } from "apollo-boost";

export const CONSUMER_CREATE_PAYMENT_FOR_EXTENSION = gql`
  mutation consumerCreatePaymentForExtension($payment: ConsumerCreatePaymentForExtensionInput!, $customerId: String, $businessCustomerId: String) {
    consumerCreatePaymentForExtension(payment: $payment, customerId: $customerId, businessCustomerId: $businessCustomerId) {
      success
      message
      payment {
        amount
        convergePaymentSessionUrl
        convergeUSSessionToken
        stripePaymentIntentSecret
        gpTransactionUrl
      }
    }
  }
`;
